const { REACT_APP_BME_URL } = process.env;

export const ProductsList = [
  {
    name: 'Sportsbook',
    slug: 'sportsbook',
    icon: 'sportsbook',
    path: 'products/sportsbook',
    shortDescription: `How to Enable and Set up BetConstruct's Sportsbook in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/Sportsbook.png').default} /><br>
                  <br>
                  <p><a href="${REACT_APP_BME_URL}products/sportsbook/overview">Sportsbook</a> is the ultimate sports-betting platform that can provide your players with</p>
                  <ul>
                  <li>45,000+ live matches and 75,000+ pre-match events every month;</li>
                  <li>120+ sports types: from football betting to tennis to volleyball and hockey, as well as horse racing - all of these available in 20+ languages;</li>
                  </ul>
                  <p>and so much more.</p>
                  <p>Sportsbook is available both as a stand-alone solution with maximum customisation and management options, as well as a robust API solution that can easily be integrated into any existing platform. It features different betting types, odds formats, popular competitions and matches, bonus and cash-out types, tax and express bonus calculation, to list a few. Sportsbook comes packed with advanced betting, risk management, marketing, analytical and Backoffice tools.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Sportsbook product page for the full list of its features.</p>
                  <p>To enable Sportsbook, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
<br/>
                  <img src=${require('../assets/imgs/products/sportsbook.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<p>The <b>Sportsbook</b> Setup includes the following fields:</p>
            <ul>
            <li><i>Max Payout</i>. This is the maximum amount that is paid out daily on any bet. The maximum payout limits apply to individual events and refer to the total return on the bet, excluding the original stake.</li>
            <li><i>Max Odd</i>. The term maximum odd defines the highest possible amount of odds. This comes in handy in the case of express bets, as odds get multiplied and can increase endlessly. So by setting the Max Odd number, you will set a growth limit for odds.</li>
            <li><i>Selection Liability</i>. Liability is a term that stands for the amount of money used to cover a bet. This liability is taken from your available balance, which ensures you have enough money to cover your worst-case scenario.</li>
            </ul>
            <p>All of these are the minimal settings and basic limits you have to set up in order to start using Sportsbook. For full configuration and management of Sportsbook’s limits, please visit BetConstruct Backoffice. You are immediately given access to Backoffice when you start creating your project.</p>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/sportsbook/overview" target="_blank">Go to Sportsbook</a>`,
  },
  {
    name: 'Casino Suite',
    slug: 'casinoSuite',
    icon: 'casinoSuite',
    path: 'products/casinoSuite',
    shortDescription: `How to Enable and Set up BetConstruct's Casino Suite in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/CasinoSuite.png').default} /><br/>
<br/>
                  <p>BetConstruct’s  <a href="${REACT_APP_BME_URL}products/casinoSuite/overview">Casino Suite</a> comprises over 7000+ online casino games and 5,500 mobile games from BetConstruct and other big names including Microgaming, NetEnt, iSoftBet, to name a few.</p>
                  <p>You can add various bonuses, free spins, tournaments and jackpots through our promotional tools. Apart from in-house HTML5 slots and advanced branded slots, BetConstruct’s Casino Suite also features Slot Builder, a perfect solution for anyone with no coding skills to create their own online casino environment.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Casino Suite product page for the full list of its features.</p>
                  <p>To enable Casino Suite, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <br/>
                  <img src=${require('../assets/imgs/products/casinoSuite.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<p>In the Setup section, you can see the full list of online casino providers we offer at the moment. If the Enable link next to a provider’s name is activated, then you can go for that option with a single click.</p>
            <p>The yellow info sign next to some names implies that the provider requires due diligence. Click on the three vertical dots, then Request Due Diligence. Next, upload the documentation required. Our due diligence specialist will review the submitted information and deal with provider-related due diligence matters on your behalf. You will be contacted on the successful completion of the process, and the provider’s games will show up on your page.</p>
            <p>If the Enable link and the three vertical dots next to a provider’s name are greyed out, they can be activated per your request.</p>
            <p>You can use the filters on top of the providers’ list to narrow down your search.</p>
            <p>The filters are based on the Enabled/Disabled state, Activation type (Automated/Due Diligence) and Provider Name.</p>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/casinoSuite/overview" target="_blank">Go to Casino Suite</a>`,
  },
  {
    name: 'Virtual Sports',
    slug: 'virtualSports',
    icon: 'virtualSports',
    path: 'products/virtualSports',
    shortDescription: `How to Enable and Set up BetConstruct's Virtual Sports in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/VirtualSports.png').default} />
                  <p>With <a href="${REACT_APP_BME_URL}products/virtualSports/overview">Virtual Sports</a>, you can offer your players a 24/7 realistic experience with BetConstruct’s diverse portfolio.</p>
                  <p>Inspired by real sporting events, this product comprises 9 sport types with enhanced 3D visualisation and rich sound effects:</p>
                  <p>
                  Virtual Football Pro,<br/>
                  Virtual Football League,<br/>
                  Virtual Football Penalty Kicks,<br/>
                  Horse Racing,<br/>
                  Greyhound Racing,<br/>
                  Car Racing,<br/>
                  Virtual Bicycle,<br/>
                  Virtual Tennis and<br/>
                  Marble Racing.
                  </p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Virtual Sports product page for the full list of its features.</p>
                  <p>To enable Virtual Sports, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, you can proceed to set up your Virtual Sports. </p>
                  <p>Let’s take a look at the <b>Setup</b> section.</p>`,
    setup: `<p>The Setup section contains the list of providers we have. If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider. If the Enable link is deactivated, just contact your account manager to switch the function on for you.</p>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/virtualSports/overview" target="_blank">Go to Virtual Sports</a>`,
  },
  {
    name: 'Backgammon',
    slug: 'backgammon',
    icon: 'backgammon',
    path: 'products/backgammon',
    shortDescription: `How to Enable and Set up BetConstruct's Backgammon in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/Backgammon.png').default} />
                  <p>Run as a separate network or part of our global one, BetConstruct’s acclaimed <a href="${REACT_APP_BME_URL}products/backgammon/overview">Backgammon</a> offers 7 game varieties in one single environment: Backgammon, Long, Nack, Hyper, Asian, Tapa, Khachapuri.</p>
                  <p>Numerous bonuses, rake back, rake race, satellite, and a few types of tournaments are all possible with BetConstruct’s Backgammon.</p>
                  <p>All the Backgammon types feature eye-pleasing modern UX design and come with such customisable features as branding, languages, themes, sounds, as well as the 3D and 2D versions of the game. There are various options and settings to configure the appearance of the board, the dice and the checkers according to the user’s taste.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Backgammon product page for the full list of its features.</p>
                  <p>To enable Backgammon, just click the green <b>Enable</b> button.</p>
                   <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <img src=${require('../assets/imgs/products/backgammon.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<ul>
              <li>In the Setup section, you will see a block for configuring <i>iOS</i> and <i>Android applications</i>. By default, it says it’s not available. That is because this is a specific procedure performed by request. So, if you need it, just request it.</li>
              <li>The <i>Join Global Network</i> is also non-tickable. Additional documentation and a certain amount of information (this will depend on the type of your project) may be required to activate it. Once the box has been activated and you’ve joined, you will see the information you’ve provided right here.</li>
              <li><i>Support URL</i> is supposed to be the URL your users will be directed to in order to contact the support team via the Live Chat. <i>Cashier URL</i> is the URL of the page, via which your users will pay in or withdraw their money. Both Support and Cashier URLs require a precise HTTP-address. This means the presence of the “http://” bit in the URL is obligatory.</li>
              <li><i>Table Logo</i> is the logo that will be displayed with your tables by default. The acceptable upload format is SVG.</li>
              <li><i>Default Avatar</i> is what’s displayed as your users’ avatar by default unless they prefer to upload a different one. The acceptable upload format is PNG.</li>
              <li>Tick <i>Web Application</i>, if you need it, along with Desktop Application, if you want it to be downloadable. The downloadable option will reveal a block for additional configuration.</li>
              <li>Once you’ve saved your choices and completed the full setup, you’ll be presented with a <i>Web Link</i> and a <i>Mobile Link</i>, alongside <i>Download URLs</i> for Windows, Windows XP and macOS.</li>
              <li><i>Package name</i> is the automatically generated name of the product that can be changed. The same goes for <i>Product Name</i>. You must select the <i>Languages</i> you want your downloadable application to have. For <i>Registration URL</i> u <i>Forgot Password URL</i>, the rules are the same as with Support and Cashier URLs: precise HTTP-address is required. The acceptable format for the <i>Logo</i> upload is PNG.</li>
            </ul>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/backgammon/overview" target="_blank">Go to Backgammon</a>`,
  },
  {
    name: 'Live Casino',
    slug: 'liveCasino',
    icon: 'liveCasino',
    path: 'products/liveCasino',
    shortDescription: `How to Enable and Set up BetConstruct's Live Casino in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/LiveCasino.png').default} />
                  <p><a href="${REACT_APP_BME_URL}products/liveCasino/overview">Live Casino</a> is an omnichannel solution</p>
                  <ul>
                  <li>packed with highly engaging live casino games, all broadcast in 6 languages;</li>
                  <li>featuring a 33-tables interface and rich game stats;</li>
                  <li>chat options with the dealer and other players;</li>
                  <li>stunning animation and sound effects for the most positive player experience.</li>
                  </ul>
                  <p>The multi-camera view makes it possible to follow the course of the game from different angles, as it adds a real-life feel to our Live Casino.
                  BetConstruct’s Live Casino software comes in 3 solutions:
                  </p>
                  <ul>
                  <li>Generic tables,</li>
                  <li>Dedicated tables and</li>
                  <li>Online Setup for land-based casinos.</li>
                  </ul>
                  <p>At an additional cost, customisation is possible for a number of aspects of the live dealer experience on dedicated tables: dealer attire, cards, table design, equipment and studio environment.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Live Casino product page for the full list of its features.</p>
                  <p>To enable Live Casino, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <img src=${require('../assets/imgs/products/liveCasino.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<p>In the Setup section, you can see the full list of online casino providers we offer at the moment. If the Enable link next to a provider’s name is activated, then you can go for that option with a single click.</p>
            <p>The yellow info sign next to some names implies that the provider requires due diligence. Click on the three vertical dots, then Request Due Diligence. Next, upload the documentation required. Our due diligence specialist will review the submitted information and deal with provider-related due diligence matters on your behalf. You will be contacted on the successful completion of the process, and the provider’s games will show up on your page.</p>
            <p>If the Enable link and the three vertical dots next to a provider’s name are greyed out, they can be activated per your request.</p>
            <p>You can use the filters on top of the providers’ list to narrow down your search. The filters are based on the Enabled/Disabled state, Activation type (Automated/Due Diligence) and Provider Name.</p>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/liveCasino/overview" target="_blank">Go to Live Casino</a>`,
  },
  {
    name: 'Skill Games',
    slug: 'skillGames',
    icon: 'skillGames',
    path: 'products/skillGames',
    shortDescription: `How to Enable and Set up BetConstruct's Skill Games in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/SkillGames.png').default} />
                  <p>BetConstruct’s <a href="${REACT_APP_BME_URL}products/skillGames/overview">Skill Games</a> software features Chinese Poker, Backgammon, Belote and Checkers, to name a few. We offer full customisation to achieve a welcoming online environment with a tailored look and feel for your players. The interface is highly attractive and user-friendly. It’s an ideal environment for multiple tournaments.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Skill Games product page for the full list of its features.</p>
                  <p>To enable Skill Games, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <img src=${require('../assets/imgs/products/skillGames.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<p>In the Setup section, you can see the list of Skill Games providers we offer at the moment. If the Enable link next to a provider’s name is activated, then you can go for that option with a single click. Currently, BetConstruct and ParagonexDynamic are the one-click providers on the list. As for the rest, they can be enabled per your request.</p>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/skillGames/overview" target="_blank">Go to Skill Games</a>`,
  },
  {
    name: 'Poker',
    slug: 'poker',
    icon: 'poker',
    path: 'products/poker',
    shortDescription: `How to Enable and Set up BetConstruct's Poker in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/Poker.png').default} />
                  <p>The software behind BetConstruct's online <a href="${REACT_APP_BME_URL}products/poker/overview">Poker</a>games is powerful, feature-rich and easy to operate. It is fully customisable and comes with Download, HTML5 Web client, iOS and Android native card rooms, integrated payment solutions, sophisticated Backoffice, CRM, Affiliate and Agent modules and 24/7 gameplay integrity.</p>
                  <p>BetConstruct’s Poker offers game varieties in one single environment: Texas Hold’em, Omaha, Short Deck Hold'Em, Spin&Go. You can either run separate card rooms or join our global network.</p>
                  <p>Deposit bonuses, rakeback, rake race, tournaments are all possible with BetConstruct’s Poker. Available tournament types include Freeroll, Freezeout, Satellite, Progressive Knockout.</p>
                  <p>All the Poker games come with customisable features. These include branding, language and theme selection, advertising areas, messages, configurable sounds, chats, preferred seating options.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Poker product page for the full list of its features.</p>
                  <p>To enable Poker, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <img src=${require('../assets/imgs/products/poker.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<ul>
            <li>In the Setup section, you will see a block for configuring <i>iOS</i> and <i>Android applications</i>. By default, it says it’s not available. That is because this is a specific procedure performed by request. So, if you need it, just request it.</li>
            <li>The <i>Join Global Network</i> is also non-tickable. Additional documentation and a certain amount of information (this will depend on the type of your project) may be required to activate it. Once the box has been activated and you’ve joined, you will see the information you’ve provided right here.</li>
            <li><i>Support URL</i> is supposed to be the URL your users will be directed to in order to contact the support team via the Live Chat. <i>Cashier URL</i> is the URL of the page, via which your users will pay in or withdraw their money. Both Support and Cashier URLs require a precise HTTP-address. This means the presence of the “http://” bit in the URL is obligatory.</li>
            <li><i>Table Logo</i> is the logo that will be displayed with your tables by default. The acceptable upload format is SVG.</li>
            <li><i>Default Avatar</i> is what’s displayed as your users’ avatar by default unless they prefer to upload a different one. The acceptable upload format is PNG.</li>
            <li>Tick <i>Web Application</i>, if you need it, along with <i>Desktop Application</i>, if you want it to be downloadable. The downloadable option will reveal a block for additional configuration.</li>
            <li>Once you’ve saved your choices and completed the full setup, you’ll be presented with a <i>Web Link</i> and a <i>Mobile Link</i>, alongside <i>Download URLs</i> for Windows, Windows XP and macOS.</li>
            <li><i>Package name</i> is the automatically generated name of the product that can be changed. The same goes for <i>Product Name</i>. You must select the <i>Languages</i> you want your downloadable application to have. <i>For Registration URL</i> u <i>Forgot Password URL</i>, the rules are the same as with Support and Cashier URLs: precise HTTP-address is required. The acceptable format for the <i>Logo</i> upload is PNG.</li>
            </ul>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/poker/overview" target="_blank">Go to Poker</a>`,
  },
  {
    name: 'Live sports video streaming',
    slug: 'liveSports',
    icon: 'liveSports',
    path: 'products/liveSports',
    shortDescription: `How to Enable and Set up BetConstruct's Live Sports Video Streaming in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/LiveSports.png').default} />
                  <p>With <a href="${REACT_APP_BME_URL}products/liveSports/overview">Live Sports Video Streaming</a>, you can offer your players a complete range of betting opportunities via 11,500 unique live videos per month including 9,000+ eSports streamed in HD.</p>
                  <p>Live Sports’ on-demand Video Streaming allows your players to catch up on the event of their choice or to rewatch particular plays or sections of a game. BetConstruct’s eSports video streaming includes optional live odds feed and statistics. It provides the flexibility you require to receive odds or create them in-house.</p>
                  <p>All matches are recorded exclusively at the BetConstruct secure facility and all players are subject to BetConstruct’s rigorous risk management.</p>
                  <p>The service comes with a powerful set of reporting and monitoring tools, all combined into a single dashboard interface.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Live Sports Video Streaming product page for the full list of its features.</p>
                  <p>To enable Live Sports Video Streaming, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, you can proceed to set up your Live Sports Video Streaming. Let’s take a look at the <b>Setup</b> section.</p>`,
    setup: `<p>Here, in the Setup section, you can see the list of providers whose live video streams we can provide for your project: Betradar, Sports Media Stream, IMG, to name a few. Most of these need to be set up by your account manager, so please contact them. But there are also one-click providers, such as Twitch, for example, that don’t require a set-up procedure: you just click “Enable” next to the provider’s name.</p>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/liveSports/overview" target="_blank">Go to Live Sports Video Streaming</a>`,
  },
  {
    name: 'Friendship',
    slug: 'friendShip',
    icon: 'friendship',
    path: 'products/friendShip',
    shortDescription: `How to Enable and Set up BetConstruct's Friendship in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/Friendship.png').default} />
                  <p><a href="${REACT_APP_BME_URL}products/friendShip/overview">Friendship</a> is a platform that provides real-time data and digital content related to the most popular sporting events around the world.</p>
                  <p>This is a separate platform that SpringBME users have access to. Once you’ve enabled it, you can immediately click the VIEW under Site URL on the left side of the Friendship product page, then go and buy the live streams you want to have displayed on your website.</p>
                  <p>Friendship offers a range of popular video events streamed in HD on weekday mornings during traditionally known “quiet” hours. This gives operators the privilege to offer a truly complete range of around-the-clock betting opportunities accompanied with live-streamed videos on multiple devices.</p>
                  <p>What operators need to do is enable the Friendship platform and book only those sporting events that they want. The operator can also create auto booking rules which will automatically book matches that meet the rules' criteria.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Friendship product page for the full list of its features.</p>
                  <p>To enable Friendship, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <img src=${require('../assets/imgs/products/friendship.png').default} />`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/friendShip/overview" target="_blank">Go to Friendship</a>`,
  },
  {
    name: 'Statistics',
    slug: 'statistics',
    icon: 'statistics',
    path: 'products/statistics',
    shortDescription: `How to Enable and Set up BetConstruct's Statistics in SpringBME`,
    description: `<img src=${require('../assets/imgs/innerIcons/Statistics.png').default} />
                  <p>As a product, BetConstruct’s <a href="${REACT_APP_BME_URL}products/statistics/overview">Statistics</a> is based on complete historical (23+ years) and near-live data, ranging from competitions and matches to individual player data. It provides detailed information on opponent teams, includes a system of navigation through sports (15+), regions (130+), competitions (2400+), tournaments (700+), match results, fixtures, standings, etc.</p>
                  <p>Please see the <b>Description</b> section of SpringBME’s Statistics product page for the full list of its features.</p>
                  <p>To enable Statistics, just click the green <b>Enable</b> button.</p>
                  <p>As soon as you’ve done that, this is what the product will look like.</p>
                  <img src=${require('../assets/imgs/products/statistics.png').default} />
                  <p>Let’s proceed to the <b>Setup</b> section.</p>`,
    setup: `<ul>
            <li>Statistics allows you to use your <i>Google Analytics</i> and/or <i>Google Tag Manager IDs</i> to detect visitors to your Statistics page. So those first two fields in the Setup section are meant for that.</li>
            <li><i>Target</i>. Hint Statistics target.</li>
            <li><i>Enable “Bet Now”</i>. When ticked, this displays Bet Now buttons in Statistics, next to all the matches from your Sportsbook.</li>
            <li><i>Hide external "See More"</i>. If checked, it will hide the “See more” link in the H2H section. This option is usually used by terminal solutions.</li>
            <li><i>Disable Google analytics</i>. Ticking this will switch Google Analytics off.</li>
            <li>In the <i>Choose a Theme block</i>, you can set or change the main colours, which your Statistics page will be based on.</li>
            </ul>`,
    releaseNotes: `<p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
                   <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
                   <br><a href="${REACT_APP_BME_URL}products/statistics/overview" target="_blank">Go to Statistics</a>`,
  },
  {
    name: 'Odds Feed',
    slug: 'oddsFeed',
    icon: 'oddsFeed',
    path: 'products/oddsFeed',
    shortDescription: `Let your business benefit from our accurate and efficient sports betting data.`,
    description: `<p dir="ltr"><span><span><img src=${require('../assets/imgs/innerIcons/OddsFeed.png').default} alt="" width="602" height="212" /></span></span></p>
<p dir="ltr"><span>DESCRIPTION</span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>This product is available if you have created an</span>
<span>.</span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>Get full access to 40,000+ live matches and 65,000+ pre-matches monthly on sporting events from around the world! Odds Feed links our partners&rsquo; businesses to the latest and most accurate sports betting data. And the odds setting skills of our professional bookmakers are at your disposal.</span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>More than 300 professional BetConstruct traders offer thousands of pre-match and live betting markets on sporting events around the world. All of our odds data is collected through the Match Reporters Network (live scouts), TV and Live Video Streaming. BetConstruct&rsquo;s Odds Feed advantages include integration via JSON feed, fully automated and customisable data, continuous updates of odds during matches.</span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>Please see the Description section of SpringBME&rsquo;s Odds Feed product page for the full list of its features.</span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>To enable Odds Feed, just click the green </span><span>Enable</span><span> button.</span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>As soon as you&rsquo;ve done that, this is what the product will look like.</span></p>
<p dir="ltr"><span><span><img src=${require('../assets/imgs/products/oddsFeed2.png').default} alt="" width="602" height="460" /></span></span></p>
<p dir="ltr"><span><span>&nbsp;</span></span></p>
<p dir="ltr"><span>Let&rsquo;s proceed to the </span><span>Setup</span><span> section.</span></p>
<p><span>&nbsp;</span></p>`,
    setup: `
<p dir="ltr">&nbsp;</p>
<p dir="ltr"><span>In the Setup section,</span></p>
<p dir="ltr"><span><span><img src=${require('../assets/imgs/products/oddsFeed3.png').default} alt="" width="602" height="321" /></span></span></p>
<ul>
<li dir="ltr">
<p dir="ltr"><span>Enter your IP address in the IP field to be whitelisted.</span></p>
</li>
<li dir="ltr">
<p dir="ltr"><span>Click the Save button to initiate the whitelisting request process. You will be notified once your IP address has been whitelisted. It normally takes about 24 hours.</span></p>
</li>
<li dir="ltr">
<p dir="ltr"><span>Make sure to copy and store the key from the Key field. This is the back-end key, which you will use to establish communication with us and get the Odds Feed data.</span></p>
</li>
<li dir="ltr">
<p dir="ltr"><span>If necessary, you can download Odds Feed API Documentation on the latest updates. Available in PDF format.</span></p>
</li>
</ul>
<div id="gtx-trans" style="position: absolute; left: 16px; top: 21px;">&nbsp;</div>`,
  },
  {
    name: 'Social Gaming',
    slug: 'socialGaming',
    icon: 'socialGaming',
    path: 'products/socialGaming',
    shortDescription: 'Custom-built social games with unforgettable casino experience.',
    description: `
    <img src=${require('../assets/imgs/innerIcons/SocialGaming.png').default} /><br><br><br>
<p>
With Social Gaming, you can have your own social gaming environment custom-built according to
your preferences and requirements. Developed in HTML5, social games use the latest 3D 
visualisation and sound effects to ensure a superb gaming experience. All custom-designed games
come with Social Gaming Management Platform wherein one can manage content, promotions,
bonuses, control coins and much more.<br/>
<br/>
The feature-rich social games allow you to grant your players loyalty points, club status and rewards,
level-up bonuses, in-app friends, challenges, quests, leaderboards, tournaments and so on.<br/>
<br/>
There’s also an option to add an in-app store to sell in-game items such as coins, energy, etc. Let
your players control and personalise their accounts by setting avatars, nicknames, choosing gender,
and much more. All in all, social gaming is your best tool for customer retention and player acquisition
without any limits.<br/>
<br/>
Please see the <b>Description</b> section of SpringBME’s Social Gaming product page for the full list of its
features.<br/>
<br/>
To enable Social Gaming, just click the green <b>Enable</b> button.
<br/>
As soon as you’ve done that, this is what the product will look like.<br/>
</p>
<br/>
<img src=${require('../assets/imgs/innerIcons/SocialGamingProduct.png').default} /><br><br>
<span>Let’s proceed to the <b>Setup</b> section.</span>
    `,
setup: `
  <p>If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider. 
  If the Enable link is deactivated, just contact your account manager to switch the function on for you.</p>
  <br><b>Key Features</b><br>
  <ul>
  <li>Fully customised branded social game (game logo, unique lobby, UI/UX) </li>
  <li>An exceptional set of gameplay features </li>
  <li>Innovative designs, powerful graphic solutions, 3D animation, ultra-realistic sound effects</li>
  <li>Multi-platform solution: available on iOS, Android, Facebook and Web</li>
  <li>Multi-coin wallet</li>
  <li>Loyalty marketing tools including unlimited coupons, discounts, rewards, promotions, etc.</li>
  <li>Built-in CRM system</li>
  <li>Sending in-game marketing messages, emails and push notifications </li>
  <li>Powerful back-office tools such as player, content, bonus, gameplay management, marketing and monetisation tools, analytics and reporting, etc.) </li>
  <li>Powerful back-office tools such as play</li>
  </ul>
`,
    releaseNotes: `
  <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p><br>    
  <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>    
  
  <br><span><a href="${REACT_APP_BME_URL}products/socialGaming/overview" target="_blank">Go to Social Gaming</a></span>
`
  },
  {
    name: 'Odds Display',
    slug: 'liveMonitor',
    icon: 'liveMonitor',
    path: 'products/liveMonitor',
    shortDescription: 'All sports events and their markets exclusively displayed in one place.',
    description: `
<img src=${require('../assets/imgs/innerIcons/OddsDisplay.png').default} /><br><br><br>
<p>
Odds ​Display ​is a piece of ​desktop software connected to the Betshop Client Program. Its function
involves allowing all sports events ​to be displayed ​along with their markets. ​As a​ solution, Odds
Display software includes ​BetConstruct's acclaimed ​Sportsbook, Virtual Sports.​ ​Please contact your
account manager for more information.<br/>
<br/>
Please see the <b>Description</b> section of SpringBME’s Odds ​Display product page for the full list of its
features.
<br/>
To enable Odds ​Display, just click the green <b>Enable</b> button.<br/>
<br/>
As soon as you’ve done that, this is what the product will look like.<br/>
</p>
<br/>
<img src=${require('../assets/imgs/innerIcons/oddsdisplayprod.jpg').default} /><br><br>
<p>Let’s proceed to the <b>Setup</b> section.</p>
    `,
    setup: `
    <p>If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider. If the Enable link is deactivated, just contact your account manager to switch the function on for you.</p>
    <br><b>Key Features</b><br>
    <ul>
    <li>Odds displaying for live and prematch games</li>
    <li>Live streaming of the Virtual Sports (also available in the earlier version)</li>
    <li>Content preview on monitors</li>
    <li>Asian odds display mode</li>
    <li>Template management by the manager user</li>
    </ul>
    `,
    releaseNotes: `
    <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p><br>
    <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
    <br><span><a href="${REACT_APP_BME_URL}products/liveMonitor/overview" target="_blank">Go to Odds Display</a></span>
    `
  },
  {
    name: 'Self Service Betting Terminal',
    slug: 'terminal',
    icon: 'terminal',
    path: 'products/terminal',
    shortDescription: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.',
    description: `
    <img src=${require('../assets/imgs/innerIcons/SelfServiceBettingTerminalSoftware.png').default} /><br><br><br>
<p>
The Self-service Betting Terminal software is a desktop application created with C# technology.
Compatible with any Windows OS, it offers high-quality performance and scalability. This software is
intended for a wide range of cabinets and hardware. The interface was created with the React JS
technology, which provides a fully customisable UI. The offering includes Sportsbook, Virtual Sports,
Horse and Greyhounds Racing, Casino, Live Casino, Lottery (Keno) and more.<br/>
<br/>
Please see the <b>Description</b> section of SpringBME’s Self-service Betting Terminal product page for
the full list of its features.<br/>
<br/>
To enable Self-service Betting Terminal, just click the green <b>Enable</b> button.<br/>
<br/>
As soon as you’ve done that, this is what the product will look like.<br/>
</p>
<br/>
<img src=${require('../assets/imgs/innerIcons/SelfServiceProduct.png').default} /><br><br><br>
<p>Let’s proceed to the <b>Setup</b> section.</p>
    `,
    setup: `
    <p>If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider. If the Enable link is deactivated, just contact your account manager to switch the function on for you.</p>
    <br><b>Key Features</b><br>
    <ul>
    <li>Dual screen system for marketing, statistics, streaming content, etc.</li>
    <li>Fully customisable design</li>
    <li>Anonymous betting</li>
    <li>Authorised betting - RFID cards (Pre-paid customer card) </li>
    <li>TITO technology  processing via cash in/ticket out, ticket in/ticket out</li>
    <li>Multilingual and multi-currency system</li>
    <li>Express Bonus system</li>
    <li>Admin management tool</li>
    <li>Payout machine</li>
    </ul>
    `,
    releaseNotes: `
    <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates</p><br>
    <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
    <br><span><a href="${REACT_APP_BME_URL}products/terminal/overview" target="_blank">Go to Self-Service Betting Terminal</a></span>
    `
  },
  {
    name: 'Betshop Client',
    slug: 'betshopClient',
    icon: 'betShopClient',
    path: 'products/betShopClient',
    shortDescription: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.',
    description: `
     <img src=${require('../assets/imgs/innerIcons/BetshopClient.png').default} /><br><br><br>
<p>
The Betshop Client software is a desktop application created with C# technology. It is compatible with
any Windows OS.  Betshop Client helps cashiers serve players when taking and paying out bets,
registering clients, accepting deposits and processing withdrawal requests from online players. The
system offers Sportsbook, Virtual Sports, Horse and Greyhounds Racing, Lottery (Keno), Bet-on
Poker and more.<br/>
<br/>
Please see the <b>Description</b> section of SpringBME’s betshop-client product page for the full list of its
features.<br/>
<br/>
To enable betshop-client, just click the green <b>Enable</b> button.<br/>
<br/>
As soon as you’ve done that, this is what the product will look like.   <br/>  
</p>
<br/>
<img src=${require('../assets/imgs/innerIcons/screeen.png').default} /><br><br><br>
<p>Let’s proceed to the <b>Setup</b> section.</p>
    `,
    setup: `
    <p>If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider. If the Enable link is deactivated, just contact your account manager to switch the function on for you</p>
    <br><b>Key Features</b><br>
    <ul>
    <li>Powerful administration and reporting tools</li>
    <li>Single point of management</li>
    <li>Dual screen system for marketing, statistics, streaming content, etc.</li>
    <li>Printable Booklets and Results materials</li>
    <li>Customisable tickets for any partner brand/logo</li>
    <li>Hot Key functionality</li>
    </ul>
    `,
    releaseNotes: `
    <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p><br>
    <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
    <br><span><a href="${REACT_APP_BME_URL}products/betShopClient/overview" target="_blank">Go to BetShop Client</a></span>
    `
  },
  {
    name: 'Pocket Betshop',
    slug: 'pocketBetshop',
    icon: 'betShopPocket',
    path: 'products/betShopPocket',
    shortDescription: 'Sortable AndroidOS software to help agents serve players.',
    description: `
     <img src=${require('../assets/imgs/innerIcons/PocketBetShop.png').default} /><br><br><br>
<p>
The Pocket Betshop software is an Android-based mobile application meant to serve players through
agents and used for taking and paying out bets, etc. The application boasts high-quality performance
and scalability. This software is compatible with many Android OS terminals and can be optimised
with other devices.<br/>
<br/>
Please see the <b>Description</b> section of SpringBME’s Pocket Betshop product page for the full list of its
features.<br/>
 <br/>
To enable Pocket Betshop, just click the green <b>Enable</b> button.<br/>
<br/>
As soon as you’ve done that, this is what the product will look like.<br/>
<br/>
</p>
<img src=${require('../assets/imgs/innerIcons/poketTerminal.png').default} /><br><br><br>
<p>Let’s proceed to the <b>Setup</b> section.</p>
    `,
    setup: `
    <p>If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider. If the Enable link is deactivated, just contact your account manager to switch the function on for you.</p>
    <br><b>Key Features</b><br>
    <ul>
    <li>Powerful administration and reporting tools</li>
    <li>Hot Key functionality</li>
    <li>Multilingual system</li>
    <li>TITO technology  processing via cash in/ticket out, ticket in/ticket out</li>
    </ul>
    `,
    releaseNotes: `
    <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p><br>
    <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
    <br><span><a href="${REACT_APP_BME_URL}products/betShopPocket/overview" target="_blank">Go to Pocket Betshop</a></span>
    `
  },
  {
    name: 'Live Scouting Data',
    slug: 'liveScoutData',
    icon: 'liveScoutDataIcon',
    path: 'products/liveScoutData',
    shortDescription: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.',
    description: `
    <img src=${require('../assets/imgs/innerIcons/liveScoutData.png').default} /><br><br><br>
<p>
BetConstruct’s <b>Live Scouting Data</b> product is composed of a team of over2000 scouts delivering
real-time stats from both sports events of global scale and matches of specific local interest.
Developed to meet your requests and needs, our cost-effective and cutting-edge scouting application
transmits live scouting data of various sports events with the shortest time-to-market implementation.
</p>
    <br><b>Key Features</b><br>
    <ul>
    <li>16 sports</li>
    <li>30+ exclusive leagues</li>
    <li>75+ countries</li>
    <li>10.000+ monthly matches</li>
    <li>Under 0.5 seconds data transmission</li>
    <li>24/7 dedicated live support</li>
    </ul>
<p>
Please see the <b>Description</b> section of SpringBME’s Live Scouting Data product page for the full list of its features.
This product can be set up per your request. Just click the <b>Request</b> button.
As soon as the product has been set up, this is what it will look like.
</p>
<br/>
    <img src=${require('../assets/imgs/innerIcons/LiveScoutingDataTwo.png').default} /><br><br><br>`,
    setup: `
    <p>
If the Enable link next to a provider’s name is activated, then you can immediately go for any one-click provider.
If the Enable link is deactivated, just contact your account manager to switch the function on for you.
    </p>
    `,
    releaseNotes: `
    <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.</p>
    <br>
    <p>Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.</p>
    <br><span><a href="${REACT_APP_BME_URL}products/liveScoutData/overview" target="_blank">Go to Live Scouting Data</a></span>
    `
  },
  {
    name: 'Betting Games Software',
    slug: 'bettingGames',
    icon: 'bettingGames',
    path: 'products/bettingGames',
    shortDescription: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.',
    description: `
    <img src=${require('../assets/imgs/innerIcons/bettingGames.png').default} /><br><br><br>
   <p>
   <b>Betting Games Software</b>, a BetConstruct product, is featuring a rich palette of the best<br/>
   in-house-developed and 3rd-party games for your iGaming business.<br/>
   These are unique and engaging games suited to every player’s preference.
   Players are presented with useful and smooth in-game features that offer them vast possibilities
   to manage their gameplay as easily as possible.<br/>
   The simplicity of gameplay and the prospect of instant income growth may be just what your 
   business needs, while available progressive cash bonuses encourage players to place more bets
   on more outcomes of the game, thus increasing the turnover of your casino.<br/>
   <br/>
   The betting games are all BetConstruct in-house developed RNG games.
   They come packed with rounds and rounds of gameplay, 24/7 wagers, and a non-stop gaming experience.
   Built on easy-to-understand principles, all games are accessible globally.
   They serve as an ideal environment for multiple promotions that can increase participation and prompt
   higher bets.
   </p><br/>
   <br/>
   <b>The features include:</b><br>
    <ul>
    <li>Desktop and mobile versions</li>
    <li>Manual and auto modes</li>
    <li>Auto-cash out features</li>
    <li>Multi-currency, multilingual</li>
    <li>Demo view opportunity</li>
    <li>24/7 availability</li>
    <li>Local/global networks</li>
    </ul><br>
    <p>Please see the <b>Description</b> section of SpringBME’s Betting Games product page for the full list of its features.
     To enable Betting Games, just click the green <b>Enable </b> button.</p><br>
     <p>Let’s proceed to the <b>Setup</b> section.</p>
    `,
    setup: `
    <p>As soon as you’ve enabled the product, you'll be presented with the provider list in the Setup section.</p><br>
    <img src=${require('../assets/imgs/innerIcons/BettingGamesSoftware.png').default} /><br><br><br>
    <p>Select and enable a provider: its games will get activated and appear on your website.</p>
    `,
    releaseNotes: `
    <p>There is also the <b>Release Notes</b> section, where you can check out the latest updates.
        Please keep in mind that if you have queries or need more information, there is always the Live Chat, through which you can contact us right away. We’ll be happy to assist you with any matter.
    </p>
    <br><span><a href="${REACT_APP_BME_URL}products/bettingGames/overview" target="_blank">Go to Betting Games Software</a></span>
    `
  }
];

export const ProductsMenu = [
  {
    name: 'Description',
    slug: 'description',
  },
  {
    name: 'Setup',
    slug: 'setup',
  },
  {
    name: 'Release Notes',
    slug: 'releaseNotes',
  },
];

export const ProductsListSetup = [
  {
    slug: 'sportsbook'
  },
  {
    slug: 'casinoSuite'
  },
  {
    slug: 'virtualSports'
  },
  {
    slug: 'backgammon'
  },
  {
    slug: 'liveCasino'
  },
  {
    slug: 'skillGames'
  },
  {
    slug: 'poker'
  },
  {
    slug: 'liveSports'
  },
  {
    slug: 'friendShip'
  },
  {
    slug: 'statistics'
  },
  {
    slug: 'oddsFeed'
  },
  {
    slug: 'socialGaming'
  },
  {
    slug: 'liveMonitor'
  },
  {
    slug: 'terminal'
  },
  {
    slug: 'betShopClient'
  },
  {
    slug: 'betShopPocket'
  },
  {
    slug: 'liveScoutData'
  },
  {
    slug: 'bettingGames'
  },
]
